import styled, { css, keyframes } from "styled-components/macro";
import { Keyframes, Frame } from "react-keyframes";
import { SmsMessage } from "./Message";

type MessageFrame = {
  body?: string | null;
  duration?: number;
};

export default function MessagesKeyframes({
  messages,
}: {
  messages: MessageFrame[];
}) {
  const messageElements: MessageFrame[][] = [];

  for (let i = 0; i < messages.length; i++) {
    const message = messages[i];

    for (let j = i; j < messages.length; j++) {
      messageElements[j] = messageElements[j] || [];
      messageElements[j].push(message);
    }
  }

  return (
    <Messages>
      <Keyframes>
        {messageElements.map((frame, i) => (
          <Frame
            key={i}
            duration={
              frame[frame.length - 1].duration ||
              2000 + Math.round(Math.random() * 3000)
            }
          >
            {frame.map((message, index) =>
              index + 1 === frame.length ? (
                <Fade originRight>
                  <SmsMessage key={index}>{message.body}</SmsMessage>
                </Fade>
              ) : (
                <SmsMessage key={index}>{message.body}</SmsMessage>
              )
            )}
          </Frame>
        ))}
      </Keyframes>
    </Messages>
  );
}

const Messages = styled.div``;

const fadeInAnim = keyframes`
  from{ 
    opacity:0;
    transform: translateY(10px) scale(.9);
  }
  to{
    opacity:1;
    transform: translateY(0px) scale(1);
  }
`;

const Fade = styled.div<{ originCenter?: boolean; originRight?: boolean }>`
  animation: 300ms ${fadeInAnim};
  animation-fill-mode: both;
  transform-origin: bottom left;
  ${(p) =>
    p.originCenter &&
    css`
      transform-origin: bottom center;
    `}
  ${(p) =>
    p.originRight &&
    css`
      transform-origin: bottom right;
    `}
`;
